export const constant = {
    baseUrl: 'http://72.167.142.17:8000/'
}
